<template>
  <div id="app">
    <el-container>
      <el-header
        height="70px"
        class="header"
      >
        <div class="tr-header-bar">
          <div class="tr-navigator">
            <div class="logo">
              <img
                src="~@/assets/images/logo.png"
                height="54px"
                width="66px"
                alt=""
              />
            </div>
            <div
              class="navi-item"
              @click="home"
            >首页</div>
            <div
              class="navi-item"
              @click="toPlay"
            >玩+专区</div>
            <div class="navi-item">
              <img
                :src="activityPhoto"
                alt
                @click="write"
              />
            </div>
          </div>
          <div
            v-if="$root.isLogin"
            class="tr-message-notice"
            @click="lookThroughMessage()"
          >
            <div class="message-notice-img"></div>
            <div class="message-notice-number">
              {{ pushMessageAccount }}
            </div>
          </div>
          <div class="tr-person">
            <div
              class="no-user"
              v-if="!$root.isLogin"
            >
              <span @click="toLoginOrOut('login')">登录</span>
              <span>|</span>
              <span @click="toLoginOrOut('register')">注册</span>
            </div>
            <div v-if="$root.isLogin">
              <el-dropdown
                trigger="click"
                @command="toPage"
              >
                <span class="el-dropdown-link">
                  <img
                    class="img-Size"
                    :src="avatar"
                    alt
                  />
                  <i class="icon el-icon-caret-bottom"></i>
                </span>
                <el-dropdown-menu
                  slot="dropdown"
                  style="z-index:9999999999!important"
                >
                  <el-dropdown-item command="info">
                    <span class="my-info"></span>我的信息
                  </el-dropdown-item>
                  <el-dropdown-item command="write">
                    <span class="write-travel"></span>写游记
                  </el-dropdown-item>
                  <el-dropdown-item command="travel">
                    <span class="my-travel"></span>我的游记
                  </el-dropdown-item>
                  <el-dropdown-item command="comment">
                    <span class="my-comment iconfont iconwodepinglun"></span>我的评论
                  </el-dropdown-item>
                  <el-dropdown-item command="want">
                    <span class="want"></span>我想去
                  </el-dropdown-item>
                  <el-dropdown-item command="logout">
                    <span class="logout"></span>退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </el-header>
      <el-main class="main-container">
        <div
          class="travel-writing"
          v-if="$root.showWriteBall"
          :style="writingBallStyle"
        >
          <img
            class="travel-writing-img"
            @click="write()"
            src="./assets/images/travel/write-note-icon.png"
            alt
          />
        </div>
        <keep-alive v-if="$route.meta.keepAlive">
          <router-view />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </el-main>
      <el-footer
        v-show="$root.showBottomArea"
        height="400px"
        class="footer"
      >
        <div class="qrcode">
          <div class="item">
            <span>
              <img
                :src="qrcodeLJ"
                alt
              />
            </span>
            <span>鹿驾公众号</span>
          </div>
          <div class="item">
            <span>
              <img
                :src="qrcodeService"
                alt
              />
            </span>
            <span>鹿驾客服</span>
          </div>
        </div>
        <div class="protocal">
          <span @click="$router.push({ path: '/about' })">关于我们</span>
          <span @click="$router.push({ path: '/protocal/privacy' })">隐私协议</span>
          <span @click="$router.push({ path: '/protocal/serve' })">游记协议</span>
        </div>
        <div class="copyright">
          备案号：辽宁ICP备11005457号-6 Copyright © 2016.沈阳美行科技有限公司
          保留所有版权
        </div>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import activityPhoto from "@/assets/images/activity.gif";
import qrcodeLJ from "@/assets/images/lujia.jpg";
import qrcodeService from "@/assets/images/service.jpg";
import headAvatar from "@/assets/images/avatar.png";
import { mapState, mapActions, mapMutations } from "vuex";
import { Loading } from "element-ui";
import SocketIo from "socket.io-client";
export default {
  data() {
    return {
      writingBallStyle: {},
      activityPhoto: activityPhoto,
      qrcodeLJ: qrcodeLJ,
      qrcodeService: qrcodeService,
      headAvatar: headAvatar,
      isLogin: false,
      webSocket: {},
      avatar: ""
    };
  },
  mounted() {},
  computed: {
    ...mapState("PersonalStore", ["userdetailList", "pushMessageAccount"])
  },
  methods: {
    lookThroughMessage() {
      this.resetPushMessageMutaion(0);
      this.$router.push({ name: "message" }).catch(e => {});
    },
    ...mapMutations("WriteDataStore", ["bottomMutation"]),
    ...mapMutations("PersonalStore", [
      "pushMessageMutation",
      "resetPushMessageMutaion"
    ]),
    ...mapActions("PersonalStore", ["getUserdetail"]),
    getScrollTop() {
      let scroll_top = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scroll_top = document.documentElement.scrollTop;
      } else if (document.body) {
        scroll_top = document.body.scrollTop;
      }
      return scroll_top;
    },
    getScrollHeight() {
      let scrollHeight = 0,
        bodyScrollHeight = 0,
        documentScrollHeight = 0;
      if (document.body) {
        bodyScrollHeight = document.body.scrollHeight;
      }
      if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight;
      }
      scrollHeight =
        bodyScrollHeight - documentScrollHeight > 0
          ? bodyScrollHeight
          : documentScrollHeight;
      return scrollHeight;
    },
    getWindowHeight() {
      var windowHeight = 0;
      if (document.compatMode == "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight;
    },
    write() {
      //注意传参数
      this.$router
        .push({ name: "traveling", params: { id: "new" } })
        .catch(e => {});
    },
    home() {
      this.$router.push({ name: "home" }).catch(e => {});
    },
    toPlay() {
      this.$router.push({ name: "play" }).catch(e => {});
    },
    toPage(command) {
      if (command == "travel" || command == "want" || command == "comment") {
        this.$router.push({ path: `/mine/${command}` });
        this.$eventHub.$emit("typeChange", command);
      } else if (command == "info") {
        this.$router.push({ path: "/personInfo" });
      } else if (command == "write") {
        this.$router.push({ path: "/traveling/new" });
      } else if (command == "logout") {
        this.$confirm("此操作将退出登录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(() => {
            this.$cookie.remove("userInfo_userId");
            this.$cookie.remove("userInfo_token");
            this.$root.verificationLogin(false);
            this.$router.push({ path: "/" });
          })
          .catch(() => {});
      }
    },
    toLoginOrOut(command) {
      this.$router.push({ path: `/minelog/${command}` });
      this.$eventHub.$emit("pageChange", command);
    }
  },
  watch: {
    $route(to, from) {
      this.$root.showWriteBall = to.meta ? to.meta.showWriteBall : false;
    },
    userdetailList: {
      handler(value) {
        this.avatar = value.avatar ? value.avatar : this.headAvatar;
      },
      deep: true
    }
  },
  created() {
    let that = this;
    if (window.location.pathname !== "/personInfo") {
      if (this.$cookie.get("userInfo_userId") !== undefined) {
        this.getUserdetail({ userId: this.$cookie.get("userInfo_userId") });
      }
    }
    // this.$root.showWriteBall = true;
    window.onscroll = event => {
      let scrollTop = this.getScrollTop(),
        scrollHeight = this.getScrollHeight(),
        windowHeight = this.getWindowHeight();
      let scrollBottom = scrollHeight - scrollTop - windowHeight;
      let fixBottom = 400 - scrollBottom + 30;
      this.scrollTop = scrollTop;
      this.writingBallStyle =
        scrollBottom > 400 ? { bottom: "30px" } : { bottom: `${fixBottom}px` };
      this.$eventHub.$emit("windowScroll", {
        scrollTop,
        scrollBottom,
        fixBottom
      });
    };
    // ;
    let userId = this.$cookie.get("userInfo_userId");
    this.$root.verificationLogin(userId ? true : false);
    if (this.$root.isLogin) {
      let opts = {
        query: `oemId=${this.$cookie.get(
          "userInfo_productId"
        )}&appId=${this.$cookie.get("userInfo_appId")}&token=${this.$cookie.get(
          "userInfo_token"
        )}&userId=${this.$cookie.get("userInfo_userId")}`
      };
      this.webSocket = SocketIo.connect(this.globalWebsocketURL, opts);
      this.webSocket.on("connect", function() {
      });
      this.webSocket.on("push_event", function(data) {
        that.pushMessageMutation();
      });
    } else {
    }
  }
};
</script>
<style lang="css">
@import "./css/icon/iconfont.css";
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
<style lang="scss">
@import "~@/assets/color.scss";
</style>
<style lang="less">
@import "~@/lesses/app.less";
@import "~@/lesses/element.less";
</style>
